export const firebaseConfig = {
  apiKey: "AIzaSyBqPrvo4mpJfRD-vMhWPzoh-wIBBUtE0IA",
  authDomain: "paragon-outdoor-usa.firebaseapp.com",
  projectId: "paragon-outdoor-usa",
  storageBucket: "paragon-outdoor-usa.appspot.com",
  messagingSenderId: "470951527633",
  appId: "1:470951527633:web:530d88761945dd5aa631f0"
}
